import React from "react";
import Hero from "./Hero";
import AboutSection from "./HomeAbout";
import Services from "./Services";
import HomePortfolio from "./Portfolio";
import TechStackCitations from "./TechStackCitations";
import UsHome from "./Whyus";
import useSEO from "./useSEO";

const Home = () => {
  useSEO({
    title: "Core Spectators | Custom Shopify Store Development, Mobile Apps & SaaS MVPs",
    description: "Core Spectators is a full-stack software and e-commerce engineering agency. We build high-converting custom Shopify 2.0 stores, cross-platform Flutter mobile apps, and scalable SaaS MVPs.",
    keywords: "custom shopify store development, shopify plus developers, bespoke shopify themes liquid, shopify speed optimization, headless shopify hydrogen, flutter mobile app development, react native apps, saas mvp development agency, multi tenant saas architecture react node, stripe subscription billing integration, ai workflow automation consulting, enterprise n8n workflows, software engineering agency",
    canonical: "https://corespectators.com/",
    schema: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Core Spectators - Custom Shopify Stores, Mobile Apps & SaaS MVPs",
      "url": "https://corespectators.com/",
      "description": "High-converting Shopify 2.0 storefronts, cross-platform Flutter mobile applications, and custom SaaS platforms engineered for scale.",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://corespectators.com/"
          }
        ]
      }
    }
  });

  return (
    <>
      <Hero />
      <AboutSection />
      <Services isHomePage={true} />
      <HomePortfolio isHomePage={true} />
      <TechStackCitations />
      <UsHome />
    </>
  );
};

export default Home;